export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_06.c0dd138b.png";